import BadIcon from './component'

export default BadIcon
